import React, { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import api, { authHeader } from '../../../../services/API/apiConfig';
import {
  formatCNPJ,
  formatCPF,
} from '../../../../services/auxiliaryFunctions/functions';
import { Header } from '../../../components/singleComponents/headers';
import { MainTable } from '../../../components/singleComponents/tables/Table/MainTable';
import {
  BackgroundIconStyled,
  BtnStyled,
  ButtonInputStyled,
  ContentStyled,
  IconStyled,
  MiddleOfThePageStyled,
  RootStyled,
  SearchAndFilterStyled,
  SearchStyled,
  TextFieldStyled,
  TextStyled,
} from './supplierAdmin.styles';

const header = ['Fornecedor', 'Email', 'Razão social', 'CNPJ/CPF', 'Telefone'];
const row = ['name', 'email', 'corporate_name', 'document', 'phone'];

export function SupplierAdmin() {
  const navigate = useNavigate();

  const [suppliers, setSuppliers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSupplier, setFilteredSupplier] = useState();

  const handleGoToNewSupplier = () => {
    navigate('/new-supplier');
  };

  const editRow = (rowData) => {
    if (!rowData) return;
    navigate(`/new-supplier/${rowData.id}`);
  };

  useEffect(() => {
    const getSuppliers = () => {
      api
        .get('/suppliers', {
          headers: authHeader(),
        })
        .then((response) => {
          const { data } = response.data;

          setSuppliers(
            data.map((s) => {
              if (s.document && s.document.length === 11) {
                return { ...s, document: formatCPF(s.document) };
              }
              if (s.document && s.document.length === 14) {
                return { ...s, document: formatCNPJ(s.document) };
              }
              if (s.phone && s.cellphone) {
                return {
                  ...s,
                  phone: `${s.phone} / ${s.cellphone}`,
                };
              }
              if (!s.phone && s.cellphone) {
                return {
                  ...s,
                  phone: `${s.cellphone}`,
                };
              }
              return s;
            })
          );
        });
    };
    if (searchTerm === '') {
      setFilteredSupplier();
      getSuppliers();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm !== '') {
      setFilteredSupplier(
        suppliers.filter(
          (data) =>
            data.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            data.document?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm]);

  return (
    <>
      <Header page="Fornecedores" />
      <RootStyled>
        <MiddleOfThePageStyled>
          <BtnStyled
            id="new-supplier-btn"
            color="secondary"
            variant="contained"
            onClick={() => handleGoToNewSupplier()}
          >
            Cadastrar fornecedor
          </BtnStyled>
          <SearchAndFilterStyled id="suppliers-search">
            <SearchStyled>
              <TextFieldStyled
                type="search"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <ButtonInputStyled variant="contained">
                <MdSearch size={17} />
              </ButtonInputStyled>
            </SearchStyled>
          </SearchAndFilterStyled>
        </MiddleOfThePageStyled>
        <ContentStyled>
          {suppliers.length !== 0 ? (
            <MainTable
              data={filteredSupplier || suppliers}
              headings={header}
              keys={row}
              callbackClickRow={editRow}
            />
          ) : (
            <BackgroundIconStyled>
              <IconStyled size={160} />
              <TextStyled variant="h4">
                Nenhum fornecedor cadastrado até o momento.
              </TextStyled>
            </BackgroundIconStyled>
          )}
        </ContentStyled>
      </RootStyled>
    </>
  );
}
